/**
 * ChangePackageCtrl controller
 *
 * @class ChangePackageCtrl
 * @memberof mwApp/subscribers
 * @see mwApp/subscribers
 *
 * @ngdoc controller
 * @name mwApp/subscribers.controller:ChangePackageCtrl
 */
/* @ngInject */
export default function ChangePackageCtrl ($scope, $http, $uibModalInstance, subscriberId, alertLiteSvc) {
  const vm = this

  vm.subscr = {}

  vm.needSubscription = false

  vm.subscriptions = []

  /**
   * Load available to assign networks
   *
   */

  $http.get(`api/subscribers/${subscriberId}/extra?network`)
    .data()
    .then(({ payload }) => {
      vm.subscr.networks = [...payload.networks]
      vm.needSubscription = payload.needSubscription
    })
    .catch(rejection => alertLiteSvc.alertError(rejection))

  /**
   * Load available subscriptions list for network
   *
   * @memberof mwApp/subscribers:ChangePackageCtrl
   */
  vm.getSubscriptions = function () {
    $http.get(`api/subscribers/${subscriberId}/extra?subscription&networkId=${vm.subscr.network.id}`)
      .data()
      .then(({ payload }) => {
        vm.subscriptions = [...payload]
      })
      .catch(rejection => alertLiteSvc.alertError(rejection))
  }

  /**
   * Update subscriber network
   *
   * @memberof mwApp/subscribers:ChangePackageCtrl
   */
  vm.submit = function () {
    const payload = {
      networkId: vm.subscr.network.id,
      subscriptionId: vm.subscription?.id
    }
    vm.setDisable()
    $http.put(`api/subscribers/${subscriberId}/network`, payload)
      .then(() => {
        $uibModalInstance.close()
      })
      .catch(rejection => alertLiteSvc.alertError(rejection))
      .finally(vm.unsetDisable)
  }

  /**
   * Cancel assigning, close modal window
   *
   * @memberof mwApp/subscribers.controller:ChangePackageCtrl
   */
  vm.cancel = function () {
    $uibModalInstance.dismiss('cancel')
  }

  /**
   * watching for network changing
   *
   */
  $scope.$watch('vm.subscr.network.id', function () {
    if (vm.needSubscription) {
      vm.subscription = null
      vm.getSubscriptions()
    }
  })
}
